import i18next from '@/i18n';

export const getValidationMessages = () => ({
  required: i18next.t('validation.required'),
});
